export default __webpack_public_path__ + "static/media/Search-long.1ef13b43.svg";